import { FileText, Download, Award } from 'lucide-react';
import type { ProductDocument, DocumentType } from '../../types/products';
import { DOCUMENT_TYPE_LABELS } from '../../types/products';

interface ProductDocumentsProps {
  documents: ProductDocument[];
}

const documentIcons: Record<DocumentType, typeof FileText> = {
  certification: Award,
  datasheet: FileText,
};

export function ProductDocuments({ documents }: ProductDocumentsProps) {
  if (documents.length === 0) {
    return null;
  }

  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-100 dark:border-slate-700 overflow-hidden">
      <div className="flex items-center gap-3 p-4 border-b border-gray-100 dark:border-slate-700">
        <div className="w-10 h-10 bg-blue-50 dark:bg-blue-900/30 rounded-xl flex items-center justify-center">
          <FileText className="w-5 h-5 text-blue-600 dark:text-blue-400" />
        </div>
        <h3 className="font-semibold text-[#1A1A1A] dark:text-white">Dokumente</h3>
      </div>

      <div className="divide-y divide-gray-100 dark:divide-slate-700">
        {documents.map((doc) => {
          const Icon = documentIcons[doc.type] || FileText;

          return (
            <a
              key={doc.id}
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 p-4 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
            >
              <div className="w-10 h-10 bg-gray-100 dark:bg-slate-700 rounded-xl flex items-center justify-center flex-shrink-0">
                <Icon className="w-5 h-5 text-gray-600 dark:text-slate-400" />
              </div>

              <div className="flex-1 min-w-0">
                <p className="font-medium text-[#1A1A1A] dark:text-white truncate">{doc.title}</p>
                <p className="text-xs text-[#6B6B6B] dark:text-slate-400">{DOCUMENT_TYPE_LABELS[doc.type]}</p>
              </div>

              <Download className="w-5 h-5 text-[#6B6B6B] dark:text-slate-400" />
            </a>
          );
        })}
      </div>
    </div>
  );
}
